<script>
import { getContacts } from "@/api";

export default {
  name: "Contacts",
  data() {
    return {
      contacts: [],
    }
  },
  methods: {
    filteredContacts(type) {
      return this.contacts.filter(contact => contact.type === type);
    },
  },
  mounted() {
    getContacts().then(response => this.contacts = response)
  }
}
</script>

<template>
  <section>
    <div class="contacts-info">
      <h1>Контакты</h1>

      <div class="contacts-info__content contacts-info__content_mt-20">
        <address class="contacts-info__item">
          <div class="contacts-info__item-row">
            <div class="contacts-info__item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                <g clip-path="url(#clip0)">
                  <path
                    d="M58.4256 46.2872L56.0949 44.7345C61.3511 35.4898 61.2924 24.147 55.9408 14.9572C50.5893 5.76746 40.7533 0.118222 30.1188 0.12701C29.5666 0.12701 29.119 0.5746 29.119 1.12682C29.119 1.67905 29.5666 2.12663 30.1188 2.12663C40.0147 2.11925 49.1716 7.36297 54.1736 15.9019C59.1754 24.4406 59.2713 34.9923 54.4252 43.6206L46.2775 38.1883C44.7362 37.1693 42.6707 37.5047 41.5311 38.9592L37.9977 43.5075C37.5427 44.1066 36.7167 44.2803 36.0589 43.9155L35.386 43.5445C33.1554 42.3286 30.3798 40.8149 24.7877 35.2207C19.1955 29.6266 17.6787 26.8489 16.4628 24.6224L16.0939 23.9494C15.7235 23.2919 15.8941 22.462 16.4938 22.0037L21.039 18.4673C22.4933 17.3278 22.8293 15.2626 21.8109 13.721L13.7121 1.57676C12.6684 0.00702791 10.5746 -0.46423 8.95891 0.506993L3.88064 3.55752C2.28501 4.49558 1.11437 6.01481 0.614168 7.79685C-1.21451 14.4598 0.161188 25.9591 17.1007 42.9007C24.4796 50.2796 30.8237 54.6989 36.1878 57.1986C27.9316 59.064 19.2752 57.0672 12.6702 51.7739C6.06516 46.4806 2.23076 38.4669 2.25291 30.0027C2.25291 29.4505 1.80532 29.0029 1.2531 29.0029C0.700874 29.0029 0.253284 29.4505 0.253284 30.0027C0.268751 46.4923 13.6293 59.8573 30.1189 59.8783C33.2081 59.8793 36.2784 59.3955 39.2175 58.4444C41.8692 59.4349 44.6719 59.9605 47.5023 59.9982C49.0891 60.005 50.6697 59.7986 52.2016 59.3844C53.984 58.8848 55.5034 57.714 56.4409 56.1179L59.4945 51.0427C60.4671 49.4266 59.9961 47.3314 58.4256 46.2872ZM57.7756 50.0136L54.7291 55.0919C54.0555 56.2459 52.9611 57.0941 51.6755 57.4585C48.767 58.2584 44.8275 58.3583 39.7653 56.5336C39.685 56.4886 39.5988 56.455 39.5093 56.4337C33.9101 54.355 26.9581 49.9247 18.5124 41.482C2.2549 25.2253 0.854132 14.4779 2.54291 8.32587C2.90801 7.04075 3.75609 5.9465 4.90951 5.2723L9.98778 2.22576C10.6888 1.80395 11.5976 2.00841 12.0504 2.68964L16.4498 9.29463L20.1423 14.8328C20.5845 15.5015 20.4392 16.3977 19.8084 16.8925L15.2621 20.429C13.8785 21.4869 13.4834 23.4011 14.3353 24.9203L14.6963 25.5762C15.9741 27.9199 17.5628 30.8354 23.363 36.6346C29.1631 42.4337 32.0777 44.0226 34.4203 45.3003L35.0772 45.6622C36.5963 46.5139 38.5106 46.119 39.5685 44.7354L43.105 40.1891C43.5999 39.5586 44.4958 39.4134 45.1647 39.8552L57.3079 47.954C57.9892 48.4051 58.1953 49.3123 57.7756 50.0136Z"
                    fill="#580619" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="60" height="60" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="contacts-info__item-info">
              <p>Телефон:</p>
              <h3 v-for="contact in filteredContacts('phone')" :key="contact.id">
                <a :href="contact.data">{{ contact.data }}</a>
              </h3>
            </div>
          </div>
          <div class="contacts-info__item-row">
            <div class="contacts-info__item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                <g clip-path="url(#clip0)">
                  <path
                    d="M31.2373 33.99C28.9957 33.9796 26.7688 33.6284 24.6328 32.9485C21.22 31.8067 18.6851 28.9174 17.997 25.3851C17.2441 21.7586 18.6162 17.9241 21.7607 14.8651C22.0981 14.5365 22.4487 14.2217 22.8125 13.9208C26.0321 11.2253 30.3728 10.2886 34.4175 11.4164C38.3333 12.6662 41.039 16.2447 41.1743 20.3529C41.3209 22.7176 40.5502 25.0478 39.0224 26.8588C37.8441 28.343 35.935 29.0441 34.0761 28.6752C33.3159 28.5174 32.6526 28.057 32.239 27.4C31.8679 26.7617 31.7727 25.9999 31.9754 25.29C32.8499 21.9844 33.739 16.9609 33.7478 16.91C33.8099 16.5581 34.055 16.266 34.3909 16.1439C34.7267 16.0217 35.1022 16.088 35.3759 16.3177C35.6496 16.5474 35.7799 16.9058 35.7178 17.2577C35.6807 17.4667 34.8052 22.4149 33.9092 25.8012C33.8452 25.9888 33.8613 26.1945 33.9536 26.37C34.0919 26.5613 34.3005 26.6899 34.5336 26.7274C35.6715 26.9173 36.821 26.4608 37.5185 25.5419C38.7049 24.1225 39.2993 22.3009 39.1785 20.455C39.0807 17.1849 36.9364 14.33 33.8231 13.325C30.4248 12.3903 26.7841 13.1888 24.089 15.46C23.7677 15.7267 23.4552 16.0059 23.1554 16.2979C21.6008 17.8101 19.1183 20.9479 19.9548 24.9779C20.5168 27.7933 22.5277 30.1007 25.2399 31.0424C29.9299 32.5385 36.6691 32.7186 40.2199 28.3036C40.5688 27.8834 41.1902 27.8208 41.6158 28.163C42.0414 28.5051 42.1138 29.1255 41.7785 29.5565C39.1528 32.8218 35.1572 33.99 31.2373 33.99Z"
                    fill="#580619" />
                  <path
                    d="M27.8154 28.8051C26.7583 28.8233 25.7273 28.4767 24.896 27.8236C22.9766 26.2875 22.9238 23.619 23.4619 21.8017C23.6431 21.1965 23.8864 20.6117 24.188 20.0565C24.9383 18.5426 26.138 17.2976 27.6231 16.4916C29.4724 15.532 31.7319 15.8959 33.1865 17.3876C33.9081 18.1785 34.4516 19.1149 34.7805 20.1337C34.9546 20.6507 34.6822 21.2119 34.1683 21.395C33.6543 21.578 33.0885 21.3153 32.8967 20.8046C32.6596 20.0519 32.2655 19.3581 31.7405 18.7689C30.8924 17.9017 29.5711 17.7044 28.5067 18.286C27.393 18.9141 26.4979 19.8677 25.9417 21.0189C25.7079 21.4503 25.5191 21.9045 25.3782 22.3744C24.9896 23.6889 25.075 25.4044 26.1473 26.2631C27.3196 27.2045 29.2973 26.8065 30.41 25.8466C31.2392 25.1001 31.9517 24.2333 32.5237 23.2753C32.7089 22.965 33.0472 22.7787 33.4085 22.7881C33.7698 22.7976 34.0979 23.0012 34.2666 23.3208C34.4354 23.6404 34.4186 24.0262 34.2227 24.3299C33.5452 25.4588 32.7017 26.4793 31.7207 27.3572C30.6272 28.2798 29.246 28.7919 27.8154 28.8051Z"
                    fill="#580619" />
                  <path
                    d="M57 59.9999H3C1.3439 59.9981 0.00181871 58.656 0 56.9999V19.9999C1.572e-05 19.6121 0.224217 19.2593 0.575283 19.0946C0.92635 18.9299 1.34098 18.983 1.6392 19.2309L26.1763 39.6234C28.3965 41.457 31.6057 41.4564 33.8252 39.622L58.36 19.2309C58.6582 18.9825 59.0732 18.9291 59.4245 19.0939C59.7759 19.2586 60.0002 19.6118 60 19.9999V56.9999C59.9982 58.656 58.6561 59.9981 57 59.9999ZM2 22.1312V56.9999C2.00072 57.5519 2.44801 57.9992 3 57.9999H57C57.5521 57.9994 57.9995 57.552 58 56.9999V22.1312L35.1021 41.1612C32.1415 43.6079 27.8608 43.6086 24.8994 41.1627L2 22.1312Z"
                    fill="#580619" />
                  <path
                    d="M1.00098 21.0001C0.565409 21.0005 0.179684 20.7189 0.0473448 20.3039C-0.0849943 19.8889 0.0664968 19.436 0.421879 19.1842L9.42188 12.8042C9.87248 12.4919 10.4905 12.6006 10.8075 13.0479C11.1244 13.4953 11.0221 14.1144 10.5781 14.436L1.57808 20.816C1.40955 20.9359 1.20782 21.0002 1.00098 21.0001Z"
                    fill="#580619" />
                  <path
                    d="M58.9984 21.0001C58.7916 21.0002 58.5899 20.9359 58.4213 20.816L49.4213 14.436C48.9773 14.1144 48.875 13.4953 49.1919 13.0479C49.5089 12.6006 50.1269 12.4919 50.5775 12.8042L59.5775 19.1842C59.9329 19.436 60.0844 19.8889 59.9521 20.3039C59.8197 20.7189 59.434 21.0005 58.9984 21.0001Z"
                    fill="#580619" />
                  <path
                    d="M39.2409 6.99996C39.0339 7.00007 38.8319 6.93572 38.6632 6.81586L33.8832 3.42586C31.6643 1.55084 28.4219 1.53131 26.1806 3.37946L21.3406 6.81596C21.0491 7.02267 20.6694 7.05818 20.3447 6.90909C20.0199 6.76001 19.7993 6.44899 19.7661 6.09319C19.7328 5.73739 19.8919 5.39087 20.1834 5.18416L24.9634 1.79416C27.917 -0.620878 32.1685 -0.601669 35.1002 1.83996L39.8202 5.18376C40.1759 5.43554 40.3275 5.88867 40.1951 6.30384C40.0627 6.71901 39.6767 7.00063 39.2409 6.99996Z"
                    fill="#580619" />
                  <path
                    d="M1.65131 59.46C1.22988 59.4603 0.853452 59.1965 0.710085 58.8002C0.566719 58.4039 0.687191 57.9602 1.01131 57.6909L23.8313 38.7309C24.1055 38.4977 24.4839 38.4299 24.822 38.5533C25.1601 38.6767 25.4058 38.9724 25.4653 39.3274C25.5249 39.6823 25.389 40.0419 25.1096 40.2689L2.28961 59.2289C2.11045 59.3782 1.88457 59.46 1.65131 59.46Z"
                    fill="#580619" />
                  <path
                    d="M58.3487 59.46C58.1156 59.4601 57.8899 59.3784 57.711 59.229L34.891 40.269C34.6116 40.042 34.4758 39.6825 34.5353 39.3275C34.5948 38.9725 34.8405 38.6769 35.1786 38.5534C35.5167 38.43 35.8951 38.4978 36.1693 38.731L58.9887 57.691C59.3128 57.9603 59.4333 58.404 59.2899 58.8003C59.1465 59.1966 58.7701 59.4605 58.3487 59.4601V59.46Z"
                    fill="#580619" />
                  <path
                    d="M50 28.4799C49.4477 28.4799 49 28.0322 49 27.4799V7.00773C48.9971 7.02873 48.957 7.00043 48.89 6.99993H11.11C11.0658 6.99721 11.0224 7.01276 10.99 7.04293L11 27.4799C11 28.0322 10.5523 28.4799 10 28.4799C9.44772 28.4799 9 28.0322 9 27.4799V6.99993C9.03226 5.86582 9.97579 4.97148 11.11 4.99993H48.89C50.0242 4.97159 50.9676 5.86587 51 6.99993V27.4799C51 28.0322 50.5523 28.4799 50 28.4799Z"
                    fill="#580619" />
                  #580619
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="60" height="60" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="contacts-info__item-info">
              <p>Email:</p>
              <h3 v-for="contact in filteredContacts('email')" :key="contact.id">
                <a :href="contact.data">{{ contact.data }}</a>
              </h3>
            </div>
          </div>
          <div class="contacts-info__item-row">
            <div class="contacts-info__item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                <path
                  d="M49.979 6.7998C49.9712 6.76514 49.9502 6.73779 49.9399 6.70508C49.9229 6.64893 49.9004 6.59473 49.873 6.54297C49.8418 6.4834 49.8042 6.42773 49.7612 6.37598C49.7266 6.33301 49.6885 6.29297 49.647 6.25586C49.5967 6.21338 49.5415 6.17676 49.4829 6.146C49.4336 6.11621 49.3813 6.09082 49.3271 6.06982C49.2622 6.04932 49.1948 6.03564 49.127 6.02881C49.0854 6.0166 49.043 6.00684 49 6H43.958C43.7002 2.51904 42.085 0 40 0C37.915 0 36.2998 2.51904 36.042 6H33.958C33.7002 2.51904 32.085 0 30 0C27.915 0 26.2998 2.51904 26.042 6H23.958C23.7002 2.51904 22.085 0 20 0C17.915 0 16.2998 2.51904 16.042 6H13.958C13.7002 2.51904 12.085 0 10 0C7.91504 0 6.2998 2.51904 6.04199 6H1C0.447754 6 0 6.44775 0 7V59C0 59.5522 0.447754 60 1 60H49C49.5522 60 50 59.5522 50 59V56H59C59.3003 56 59.5845 55.8647 59.7739 55.6323C59.9639 55.3994 60.0391 55.0942 59.979 54.7998L49.979 6.7998ZM40 2C40.7222 2 41.73 3.53223 41.9521 6H38.0518C38.27 3.53223 39.2778 2 40 2ZM30 2C30.7222 2 31.73 3.53223 31.9521 6H28.0518C28.27 3.53223 29.2778 2 30 2ZM20 2C20.7222 2 21.73 3.53223 21.9521 6H18.0518C18.27 3.53223 19.2778 2 20 2ZM10 2C10.7222 2 11.73 3.53223 11.9521 6H8.05176C8.27002 3.53223 9.27783 2 10 2ZM2 8H6.04199C6.2998 11.481 7.91504 14 10 14C10.5522 14 11 13.5522 11 13C11 12.4478 10.5522 12 10 12C9.27783 12 8.27002 10.4678 8.04785 8H16.042C16.3032 11.481 17.915 14 20 14C20.5522 14 21 13.5522 21 13C21 12.4478 20.5522 12 20 12C19.2778 12 18.27 10.4678 18.0479 8H26.042C26.3032 11.481 27.915 14 30 14C30.5522 14 31 13.5522 31 13C31 12.4478 30.5522 12 30 12C29.2778 12 28.27 10.4678 28.0479 8H36.042C36.3032 11.481 37.915 14 40 14C40.5522 14 41 13.5522 41 13C41 12.4478 40.5522 12 40 12C39.2778 12 38.27 10.4678 38.0479 8H48V18H2V8ZM48 58H2V20H48V58ZM50 54V16.7002L57.771 54H50Z"
                  fill="#580619" />
                <path
                  d="M22 36H18C17.4478 36 17 36.4478 17 37V41C17 41.5522 17.4478 42 18 42H22C22.5522 42 23 41.5522 23 41V37C23 36.4478 22.5522 36 22 36ZM21 40H19V38H21V40Z"
                  fill="#580619" />
                <path
                  d="M32 36H28C27.4478 36 27 36.4478 27 37V41C27 41.5522 27.4478 42 28 42H32C32.5522 42 33 41.5522 33 41V37C33 36.4478 32.5522 36 32 36ZM31 40H29V38H31V40Z"
                  fill="#580619" />
                <path
                  d="M11.998 36H7.99805C7.4458 36 6.99805 36.4478 6.99805 37V41C6.99805 41.5522 7.4458 42 7.99805 42H11.998C12.5503 42 12.998 41.5522 12.998 41V37C12.998 36.4478 12.5503 36 11.998 36ZM10.998 40H8.99805V38H10.998V40Z"
                  fill="#580619" />
                <path
                  d="M22 46H18C17.4478 46 17 46.4478 17 47V51C17 51.5522 17.4478 52 18 52H22C22.5522 52 23 51.5522 23 51V47C23 46.4478 22.5522 46 22 46ZM21 50H19V48H21V50Z"
                  fill="#580619" />
                <path
                  d="M32 46H28C27.4478 46 27 46.4478 27 47V51C27 51.5522 27.4478 52 28 52H32C32.5522 52 33 51.5522 33 51V47C33 46.4478 32.5522 46 32 46ZM31 50H29V48H31V50Z"
                  fill="#580619" />
                <path
                  d="M11.998 46H7.99805C7.4458 46 6.99805 46.4478 6.99805 47V51C6.99805 51.5522 7.4458 52 7.99805 52H11.998C12.5503 52 12.998 51.5522 12.998 51V47C12.998 46.4478 12.5503 46 11.998 46ZM10.998 50H8.99805V48H10.998V50Z"
                  fill="#580619" />
                <path
                  d="M22 26H18C17.4478 26 17 26.4478 17 27V31C17 31.5522 17.4478 32 18 32H22C22.5522 32 23 31.5522 23 31V27C23 26.4478 22.5522 26 22 26ZM21 30H19V28H21V30Z"
                  fill="#580619" />
                <path
                  d="M32 26H28C27.4478 26 27 26.4478 27 27V31C27 31.5522 27.4478 32 28 32H32C32.5522 32 33 31.5522 33 31V27C33 26.4478 32.5522 26 32 26ZM31 30H29V28H31V30Z"
                  fill="#580619" />
                <path
                  d="M41.998 36H37.998C37.4458 36 36.998 36.4478 36.998 37V41C36.998 41.5522 37.4458 42 37.998 42H41.998C42.5503 42 42.998 41.5522 42.998 41V37C42.998 36.4478 42.5503 36 41.998 36ZM40.998 40H38.998V38H40.998V40Z"
                  fill="#580619" />
                <path
                  d="M41.998 46H37.998C37.4458 46 36.998 46.4478 36.998 47V51C36.998 51.5522 37.4458 52 37.998 52H41.998C42.5503 52 42.998 51.5522 42.998 51V47C42.998 46.4478 42.5503 46 41.998 46ZM40.998 50H38.998V48H40.998V50Z"
                  fill="#580619" />
                <path
                  d="M41.998 26H37.998C37.4458 26 36.998 26.4478 36.998 27V31C36.998 31.5522 37.4458 32 37.998 32H41.998C42.5503 32 42.998 31.5522 42.998 31V27C42.998 26.4478 42.5503 26 41.998 26ZM40.998 30H38.998V28H40.998V30Z"
                  fill="#580619" />
                <path
                  d="M11.998 26H7.99805C7.4458 26 6.99805 26.4478 6.99805 27V31C6.99805 31.5522 7.4458 32 7.99805 32H11.998C12.5503 32 12.998 31.5522 12.998 31V27C12.998 26.4478 12.5503 26 11.998 26ZM10.998 30H8.99805V28H10.998V30Z"
                  fill="#580619" />
              </svg>
            </div>
            <div class="contacts-info__item-info">
              <p>Часы работы:</p>

              <h3>10:00 до 20:00</h3>
            </div>
          </div>
        </address>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.contacts-info {
  padding: 0 20px;
  &__content {
    display: grid;
    // grid-template-columns: repeat(2, 1fr);
    gap: 30px;

    &_mt-20 {
      margin-top: 20px;
      padding: 0 20px;
    }

    &>address {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      row-gap: 10px;
      font-style: italic;
    }
  }

  &__item {
    border-radius: 20px;
    box-shadow: 0 12px 24px rgba(0, 0, 0, .05);

    &:first-child {
      padding: 30px;
      background: #FFFFFF;
    }

    &:last-child {
      padding: 60px 60px;
      background-size: cover;
    }

    &-row {
      display: flex;
    }

    &-icon {
      padding: 0 15px;

      &>svg {
        margin-top: 10px;
      }
    }

    &-info {
      padding: 0 15px;

      &>p {
        margin-bottom: 1rem;
        font-size: 18px;
        line-height: 1.5;
      }

      &>h3 {
        margin-bottom: .5rem;
        font-weight: bold;
        font-size: 24px;
        line-height: 1;

        &>a {
          font-weight: inherit;
          font-size: inherit;
          color: #580619;
        }
      }

      &>a {
        font-size: 18px;
        color: #580619;
      }
    }


  }
}

@media screen and (min-width: 850px) {
  @media screen and (max-width: 950px) {
    .contacts-info {
      &__item {
        &:first-child {
          padding: 20px;
        }

        &:last-child {
          padding: 40px 40px 0;
        }
      }
    }
  }

  @media screen and (max-width: 890px) {
    .contacts-info {
      &__item {
        &:last-child {
          padding: 30px 30px 0;
        }
      }
    }
  }

  @media screen and (max-width: 870px) {
    .contacts-info {
      &__item {
        &:last-child {
          padding: 20px 20px 0;
        }
      }
    }
  }
}

@media screen and (max-width: 850px) {
  .contacts-info {
    &__content {
      display: flex;
      flex-direction: column;
    }

    &__item {
      &:last-child {
        padding: 60px;
        flex-direction: column;
        align-items: center;
      }
    }
  }
}

@media screen and (max-width: 484px) {
  .contacts-info {
    &__item {

      &-icon,
      &-info {
        padding: 0 8px;
      }

      &:first-child {
        padding: 20px;
      }

      &:last-child {
        padding: 40px;
      }
    }
  }
}

@media screen and (max-width: 436px) {
  .contacts-info {
    &__item {
      &-icon {
        display: none;
      }

      &-info {


        &>p {
          margin-bottom: .5rem;
        }
      }
    }
  }
}

@media screen and (max-width: 422px) {
  .contacts-info {
    &__item {
      &:last-child {
        padding: 20px;
      }
    }
  }
}
</style>